import { date } from "quasar";

export default (dateString = Date.now(), format = "MMM DD, YYYY") => {
  if (dateString) return date.formatDate(dateString, format);
  return "-";
};
